/** 1ページ目に乗せる職歴件数（prMessage 350文字制限前提） */
const JOBS_PER_PAGE = 3

const MONTH_NAMES_SHORT = [
  '',
  '01',
  '02',
  '03',
  '04',
  '05',
  '06',
  '07',
  '08',
  '09',
  '10',
  '11',
  '12'
] as const

type EnglishResumeJobLike = {
  startMonth?: string | number
  startYear?: string | number
  endMonth?: string | number
  endYear?: string | number
  isContinuing?: boolean
}

type EnglishResumeProjectLike = {
  startMonth?: string | number
  startYear?: string | number
  endMonth?: string | number
  endYear?: string | number
}

export function formatMonthYear(
  month?: string | number,
  year?: string | number
): string {
  if (!year && !month) return ''
  const mm = month
    ? MONTH_NAMES_SHORT[Number(month)] || String(month).padStart(2, '0')
    : ''
  if (mm && year) return `${mm}/${year}`
  if (year) return `${year}`
  if (mm) return mm
  return ''
}

export function formatExperiencePeriod(
  job: EnglishResumeJobLike,
  project?: EnglishResumeProjectLike | null
): string {
  if (project) {
    const start = formatMonthYear(project.startMonth, project.startYear)
    if (project.endYear || project.endMonth) {
      const end = formatMonthYear(project.endMonth, project.endYear)
      return start && end ? `${start} - ${end}` : start || end
    }
    if (
      job.isContinuing ||
      (!project.endYear &&
        !project.endMonth &&
        !project.startYear &&
        !project.startMonth)
    ) {
      return start ? `${start} - Present` : ''
    }
    return start
  }
  const start = formatMonthYear(job.startMonth, job.startYear)
  if (job.isContinuing) {
    return start ? `${start} - Present` : 'Present'
  }
  const end = formatMonthYear(job.endMonth, job.endYear)
  return start && end ? `${start} - ${end}` : start || end
}

export function splitJobHistories<T>(jobs: T[] | undefined | null): {
  isTwoPage: boolean
  jobsPage1: T[]
  jobsPage2: T[]
} {
  const list = jobs || []
  const isTwoPage = list.length > JOBS_PER_PAGE
  if (!isTwoPage) {
    return { isTwoPage: false, jobsPage1: list, jobsPage2: [] }
  }
  return {
    isTwoPage: true,
    jobsPage1: list.slice(0, JOBS_PER_PAGE),
    jobsPage2: list.slice(JOBS_PER_PAGE)
  }
}

export function previewHighLightClass(
  cardId: string | string[],
  currentCardId: string | string[] | undefined,
  isCardChanged: boolean,
  isSample: boolean
): Record<string, boolean> {
  if (isSample) return {}
  if (typeof cardId === 'string') {
    return {
      highlight: currentCardId === cardId && isCardChanged
    }
  }
  if (Array.isArray(cardId)) {
    return {
      highlight: cardId.indexOf(currentCardId as string) !== -1 && isCardChanged
    }
  }
  return {}
}
